import defaultState from './state';

const SAVE_CLASS = (state, classObj) => {
  state.currentClass = classObj;
};

const SAVE_CLASSES = (state, classes) => {
  state.classes = { ...state.classes, ...classes };
};

const SAVE_STUDENTS = (state, students) => {
  state.students = students;
};

const SET_INVITE_TOAST = (state, value) => {
  state.inviteToast = value;
};

const SET_CLASS_DELETE_TOAST = (state, value) => {
  state.classDeleteToast = value;
};

export default {
  SAVE_CLASS,
  SAVE_CLASSES,
  SAVE_STUDENTS,
  SET_INVITE_TOAST,
  SET_CLASS_DELETE_TOAST
};



// WEBPACK FOOTER //
// ./src/store/modules/classes/mutations.js